import React from 'react'
import Icons from '../Icons'
import styled from 'styled-components'

const Input = ({value, onClick, dataTestId, icon, clearValue, ariaLabel}) => (
  <InputContainer >
    <StyledInput data-testid={dataTestId || 'input-input'}>
      {value}
      {value &&
        clearValue && (
          <StyledClearButton>
            <Icons
              icon={'CLEAR'}
              onClick={evt => {
                evt.stopPropagation()
                clearValue()
              }}
            />
          </StyledClearButton>
        )}
    </StyledInput>

    <StyledButton aria-label={ariaLabel} onClick={onClick} onKeyDown={onClick}>
      <Icons icon={icon || 'DOWN_ARROW'} />
    </StyledButton>
  </InputContainer>
)

export default Input

const InputContainer = styled.div`
  display: flex;
  user-select: none;
`

const StyledInput = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 46px;
  background-color: #f3f5fb;
  border: 0;
  border-radius: 6px 0 0 6px;
  padding-left: 20px;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.3px;
  color: #000000;
  user-select: none;
`

const StyledButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  box-shadow: 0 1px 6px 0 rgba(51, 149, 254, 0.38);
  border-radius: 4px;
  width: 46px;
  height: 46px;
  padding: 12px;
  cursor: pointer;
  
  :focus { 
  	outline: 3px solid #FF9900;
  }
`

const StyledClearButton = styled.div`
  margin-left: auto;
  width: 46px;
  height: 46px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`
